// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

export default {
	currentPage: {
		tokenValidation: true,
		restoreRequest: false,
		restoreResponse: false
	},
	restoreStatus: {
		status: 'success',
		requestId: ''
	},
	accessToken: '',
	userInfo: {
		eid: '',
		mid: ''
	},
	tokenValidationError: '',
	language: 'en',
	langChanged: false
};
